"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function ProjectsHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section id="projects-hero" ref={ref} className="relative w-full h-screen overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/accra_villa_hero_render.png)]" style={{
      transform: `translateY(${scrollY * 0.3}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-primary/20 to-transparent" />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
        <div className={`max-w-4xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-primary mb-6 leading-tight">
            Trust is Not a Luxury.
            <br />
            It is a Guarantee.
          </h1>

          {}
          <p className="text-xl md:text-2xl text-foreground-primary/90 mb-12 font-sans">
            Discover premium development projects with{" "}
            <span className="text-accent font-semibold">
              Radical Transparency
            </span>
          </p>

          {}
          <Button asChild size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover active:bg-accent-active font-semibold text-lg px-8 py-6 rounded-md shadow-medium transition-all duration-[var(--duration-fast)] ease-in-out hover:shadow-strong hover:-translate-y-1 relative after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0.5 after:bg-accent-dark after:transition-all after:duration-[var(--duration-fast)] hover:after:w-3/4">
            <Link to="#the-project">Explore Units</Link>
          </Button>
        </div>
      </div>
    </section>;
}